import React, { useState } from 'react';
import { Box, Button, Drawer, IconButton, Link, Typography } from '@mui/material';
import { CloseIcon, MenuIcon } from '../../../../../constants/icons';
import { imageAssetUrl } from '../../../../../utils/publicAssets';

const roadmapImages = [
  imageAssetUrl('05_08_2006_Roadmap_1.png'),
  imageAssetUrl('05_08_2006_Roadmap_2.png'),
  imageAssetUrl('05_08_2006_Roadmap_3.png'),
  imageAssetUrl('05_08_2006_Roadmap_4.png'),
  imageAssetUrl('05_08_2006_Roadmap_5.png'),
  imageAssetUrl('05_08_2006_Roadmap_6.png')
];

const navigationItems = [
  { label: 'Giveaway', href: '/giveaway' },
  { label: 'Subscribe', href: '/#section2-3' },
  { label: 'Digital Collectibles', href: '/#section4' },
  { label: 'RPG', href: '/#section3' },
  { label: 'About Us', href: '/#section9' },
  { label: 'Roadmap', href: '/roadmap' }
];

const Roadmap = () => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);

  return (
    <Box
      component="main"
      sx={{
        width: '100%',
        minHeight: '100vh',
        background: '#ffffff',
        py: 0
      }}
    >
      <Box
        component="header"
        sx={{
          display: { xs: 'flex', lg: 'none' },
          alignItems: 'center',
          justifyContent: 'space-between',
          width: '100%',
          boxSizing: 'border-box',
          px: 2,
          py: 1.25,
          position: 'sticky',
          background:
            'linear-gradient(180deg, rgba(0, 0, 0, 0.96) 0%, rgba(0, 0, 0, 0.82) 100%)',
          backdropFilter: 'blur(12px)',
          borderBottom: '1px solid rgba(255,255,255,0.08)',
          top: 0,
          left: 0,
          right: 0,
          zIndex: 3000,
          lineHeight: 0
        }}
      >
        <Link href="/" underline="none" sx={{ display: 'flex', width: '72%' }}>
          <Box
            component="img"
            src="https://incrypt-dynamic-website-images.s3.ap-southeast-2.amazonaws.com/logo.png"
            alt="Incrypt"
            sx={{ width: '100%', maxWidth: 270 }}
          />
        </Link>

        <IconButton
          aria-label={
            isMobileMenuOpen ? 'Close navigation menu' : 'Open navigation menu'
          }
          onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
          sx={{
            width: 52,
            height: 52,
            borderRadius: '16px',
            backgroundColor: 'rgba(255,255,255,0.96)',
            color: '#0d0d0d',
            boxShadow: '0 10px 24px rgba(0,0,0,0.28)',
            '&:hover': {
              backgroundColor: 'white'
            }
          }}
        >
          <MenuIcon sx={{ fontSize: 34 }} />
        </IconButton>
      </Box>

      <Drawer
        anchor="top"
        open={isMobileMenuOpen}
        onClose={() => setIsMobileMenuOpen(false)}
        ModalProps={{ keepMounted: true, disablePortal: true }}
        PaperProps={{
          sx: {
            width: '100%',
            height: '100%',
            background: 'linear-gradient(180deg, #ffffff 0%, #f7f9fc 100%)',
            color: '#111827'
          }
        }}
      >
        <Box
          sx={{
            minHeight: '100%',
            display: 'flex',
            flexDirection: 'column',
            px: 2,
            pt: 2,
            pb: 4
          }}
        >
          <Box
            sx={{
              display: 'flex',
              justifyContent: 'space-between',
              alignItems: 'center',
              gap: 2,
              pb: 2,
              borderBottom: '1px solid rgba(15, 23, 42, 0.08)'
            }}
          >
            <Box>
              <Typography
                sx={{
                  fontSize: '0.78rem',
                  letterSpacing: '0.24em',
                  textTransform: 'uppercase',
                  color: 'rgba(15, 23, 42, 0.45)',
                  mb: 0.5
                }}
              >
                Incrypt
              </Typography>
              <Typography variant="h5" sx={{ fontWeight: 800, lineHeight: 1.1 }}>
                Explore the universe
              </Typography>
            </Box>

            <IconButton
              aria-label="Close navigation menu"
              onClick={() => setIsMobileMenuOpen(false)}
              sx={{
                width: 48,
                height: 48,
                backgroundColor: '#111827',
                color: 'white',
                '&:hover': {
                  backgroundColor: '#1f2937'
                }
              }}
            >
              <CloseIcon />
            </IconButton>
          </Box>

          <Box
            sx={{
              display: 'flex',
              flexDirection: 'column',
              gap: 1.25,
              mt: 3
            }}
          >
            {navigationItems.map((item) => (
              <Link
                key={item.label}
                href={item.href}
                onClick={() => setIsMobileMenuOpen(false)}
                underline="none"
                sx={{ color: '#111827', textDecoration: 'none' }}
              >
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    px: 2.25,
                    py: 2,
                    borderRadius: '20px',
                    backgroundColor: '#ffffff',
                    border: '1px solid rgba(15, 23, 42, 0.1)',
                    boxShadow: '0 12px 30px rgba(15, 23, 42, 0.08)'
                  }}
                >
                  <Typography
                    sx={{
                      color: '#111827',
                      fontWeight: 800,
                      fontSize: '1.4rem',
                      lineHeight: 1.05
                    }}
                  >
                    {item.label}
                  </Typography>
                </Box>
              </Link>
            ))}
          </Box>

          <Box sx={{ mt: 'auto', pt: 3 }}>
            <Link
              href="/login"
              underline="none"
              onClick={() => setIsMobileMenuOpen(false)}
            >
              <Button
                fullWidth
                variant="contained"
                sx={{
                  py: 1.6,
                  borderRadius: '18px',
                  background: '#111827',
                  color: 'white',
                  fontWeight: 800,
                  fontSize: '1rem',
                  boxShadow: '0 18px 36px rgba(15, 23, 42, 0.18)',
                  '&:hover': {
                    background: '#1f2937'
                  }
                }}
              >
                Login
              </Button>
            </Link>
          </Box>
        </Box>
      </Drawer>

      <Box
        sx={{
          width: '100%',
          maxWidth: 1000,
          mx: 'auto',
          pt: 0,
          px: { xs: 0, sm: 2 }
        }}
      >
        {roadmapImages.map((src, index) => (
          <Box
            component="img"
            key={src}
            src={src}
            alt={`Incrypt roadmap ${index + 1}`}
            sx={{
              display: 'block',
              width: '100%',
              maxWidth: 1000,
              height: 'auto',
              objectFit: 'contain'
            }}
          />
        ))}
      </Box>
    </Box>
  );
};

export default Roadmap;
